import * as f from '../../../components/BPMTable/BPMInputs'
import {
    DataMapper,
    TableFieldDescription,
    DateTimeComponentCreator,
    DateDisplayCreator,
    StateComponentCreator,
    StateExcelDisplayCreator,
    StatusComponentCreator,
    BooleanExcelDisplayCreator,
    HideCrudDisplayStrategy,
} from '../../../components/BPMTable/TableMapperCreator'
import { ExportFooterItemCreator } from '../../../components/BPMTable/TableFooterItems'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import { DirectTableQueryBuilder } from '../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder'
import { FetchFilesRowActionButtonCreator, ProcessRowActionButtonCreator, DownloadFilesRowActionButtonCreator, EditFilesRowActionButtonCreator } from './AvailableInvoiceActions'

let editMutator
let newMutator
let deleteMutator

const availableInvoiceStatuses = {
    'PENDING': 'Pending',
    'DOWNLOADED': 'Downloaded',
    'PROCESSING': 'Processing',
    'DONE': 'Done',
    'FAILED': 'Failed',
}

const AvailableInvoiceTableCreatorQueries = {
    tableQueryBuilder: new DirectTableQueryBuilder('allAvailableInvoices'),
    editMutator,
    newMutator,
    deleteMutator,
}

class AvailableInvoiceTableCreator extends TableCreatorCreator {
    constructor(filters) {
      super(filters)
    }

    static getId = () => {
        return 'AvailableInvoiceTableCreator'
    }

    getTableCreator = (tableName) => {
        const tableCreator = this.createTableCreator(this.constructor.getId(), tableName, AvailableInvoiceTableCreatorQueries)
        tableCreator.setTableFooterItems([new ExportFooterItemCreator()])
        tableCreator.setInitialSortField('createdAt', 'desc')
        tableCreator.addDescriptions([
            new TableFieldDescription(
                'pk',
                new DataMapper('pk'),
                new f.FilterDescription(new f.NullCreator()),
                { label: 'pk', hidenField: true }
            ),
            new TableFieldDescription(
                'vendor',
                new DataMapper('vendor.name'),
                new f.FilterDescription(new f.TextFilter('vendor')),
                { label: 'Vendor' }
            ),
            new TableFieldDescription(
                'driver',
                new DataMapper('driver.name'),
                new f.FilterDescription(new f.TextFilter('driver')),
                { label: 'Driver' }
            ),
            new TableFieldDescription(
                'domain',
                new DataMapper('domain.name'),
                new f.FilterDescription(new f.TextFilter('domain')),
                { label: 'Domain' }
            ),
            new TableFieldDescription(
                'period',
                new DataMapper('period.date'),
                new f.FilterDescription(new f.PeriodFilter('period')),
                { label: 'Period' }
            ),
            new TableFieldDescription(
                'accountNumber',
                new DataMapper('accountNumber'),
                new f.FilterDescription(new f.TextFilter('accountNumber')),
                { label: 'Account' }
            ),
            new TableFieldDescription(
                'status',
                new DataMapper('status'),
                new f.FilterDescription(new f.TextFilter('status')),
                {
                    label: 'Status',
                    componentCreator: new StateComponentCreator(availableInvoiceStatuses),
                    excelDisplay: new StateExcelDisplayCreator(availableInvoiceStatuses),
                }
            ),
            new TableFieldDescription(
                'createdAt',
                new DataMapper('createdAt'),
                new f.FilterDescription(new f.NullCreator()),
                { label: 'Created At', componentCreator: new DateTimeComponentCreator(), excelDisplay: new DateDisplayCreator() }
            ),
            new TableFieldDescription(
                'updatedAt',
                new DataMapper('updatedAt'),
                new f.FilterDescription(new f.NullCreator()),
                { label: 'Updated At', componentCreator: new DateTimeComponentCreator(), excelDisplay: new DateDisplayCreator() }
            ),
            new TableFieldDescription(
                'filesComplete',
                new DataMapper('filesComplete'),
                new f.FilterDescription(new f.NullCreator()),
                {
                    label: 'Files Ready',
                    componentCreator: new StatusComponentCreator(),
                    excelDisplay: new BooleanExcelDisplayCreator('Yes', 'No'),
                }
            ),
            new TableFieldDescription(
                'files',
                new DataMapper('files'),
                new f.FilterDescription(new f.NullCreator()),
                { label: 'files', hidenField: true }
            ),
        ])

        tableCreator.addRowActionButtonCreator(new FetchFilesRowActionButtonCreator())
        tableCreator.addRowActionButtonCreator(new EditFilesRowActionButtonCreator())
        tableCreator.addRowActionButtonCreator(new ProcessRowActionButtonCreator())
        tableCreator.addRowActionButtonCreator(new DownloadFilesRowActionButtonCreator())

        tableCreator.setDisplayStrategy(new HideCrudDisplayStrategy())

        return tableCreator
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(AvailableInvoiceTableCreator)

export { AvailableInvoiceTableCreator }
